import uajs from './module/ua';

(function ($) {
	const ua = uajs();

	$(document).ready(function () {

		// 768px以上のviewport
		if ($(window).width() > 767) {
			$('meta[name="viewport"]').attr('content', 'width=1020');
		}

		// アンカーリンク　自動で共通ヘッダー分の高さを考慮
		$('a').click(function (e) {
			let href = $(this).attr('href');
			if (href.match(/^#/) && $(href).length > 0) {
				e.preventDefault();
				$('html, body').animate({
					scrollTop: $(href).offset().top
				}, 'fast');
			}
		});

		// アンカーリンクactive表示
		var sectionArr = new Array(),
			elIndex = $('.l-nav .l-nav__link');
		for (i = 0; i < elIndex.length; i++) {
			var elLink = elIndex.eq(i).attr('href');
			sectionArr[i] = elLink;
		}
		$(window).on('load resize scroll', function () {
			var top = $(window).scrollTop() + ($(window).height() / 2);
			for (i = 0; i < sectionArr.length; i++) {
				var target = sectionArr[i],
					secTop = $(target).offset().top,
					secBottom = secTop + $(target).outerHeight(true);
				if (secTop <= top && secBottom >= top) {
					elIndex.removeClass('js-nav-current');
					elIndex.eq(i).addClass('js-nav-current');
				}
			}
		});

		// モーダル swipebox
		$('.swipebox').swipebox({});

		// アニメーション用　表示されたらclass追加
		$(window).on('scroll', function () {
			$(".p-anime").each(function () {
				var position = $(this).offset().top;
				var scroll = $(window).scrollTop();
				var windowHeight = $(window).height();
				if (scroll > position - windowHeight + windowHeight / 10) {
					$(this).addClass('js-anime');
				}
				// else {
				// 	$(this).removeClass('js-anime');
				// }
			});
		});

		// footer用　納税リストが表示されたらclass追加
		$(window).on('scroll', function () {
			$(".p-top__bnr-furusato-list").each(function () {
				var position = $(this).offset().top;
				var scroll = $(window).scrollTop();
				var windowHeight = $(window).height();
				if (scroll > position - windowHeight + windowHeight / 7) {
					$('.l-footer').addClass('js-anime');
				}
			});
		});

		// intro-mv, item slick
		function checkBreakPoint() {
			w = $(window).width();
			if (w <= 767) {
				$('.js-mv-slider').not('.slick-initialized').slick({
					slidesToShow: 3,
					slidesToScroll: 1,
					arrows: true,
					autoplay: true,
					infinite: true,
					centerMode: true,
					pauseOnFocus: false,
					variableWidth: true,
					speed: 600
				});

				$('.js-buy-slider').not('.slick-initialized').slick({
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					autoplay: true,
					centerMode: true,
					centerPadding: '33%',
					pauseOnFocus: false,
					speed: 1000
				});
			} else {
				$('.js-mv-slider.slick-initialized').slick('unslick');

				$('.js-buy-slider.slick-initialized').slick('unslick');
			}
		}
		// slickウインドウがリサイズする度にチェック
		$(window).resize(function () {
			checkBreakPoint();
		});
		// slick初回チェック
		checkBreakPoint();

		// gsap
		// common
		gsap.timeline({
			defaults: {
				duration: 1,
				delay: 1,
				ease: "power2.inOut"
			}
		});

		// ScrollTrigge common
		ScrollTrigger.defaults({
			start: 'top 65%'
		});

		// p-top__intro-ttl
		gsap.set(".p-top__intro-ttl .js-gsap-pc", {
			opacity: 0,
		});

		gsap.to(".p-top__intro-ttl .js-gsap-pc", {
			duration: 4,
			delay: 0,
			opacity: 1,
			scrollTrigger: {
				trigger: '.p-top__intro-ttl .js-gsap-pc',
			},
			stagger: {
				from: "start",
				amount: 1.5,
			}
		});

		gsap.set(".p-top__intro-ttl .js-gsap-sp", {
			opacity: 0,
		});

		gsap.to(".p-top__intro-ttl .js-gsap-sp", {
			duration: 8,
			opacity: 1,
			ease: "power0.easeOut",
			scrollTrigger: {
				trigger: '.p-top__intro-ttl .js-gsap-sp',
				start: 'top 55%'
			},
			stagger: {
				from: "start",
				amount: 2,
			}
		});

		// p-top__intro-text
		gsap.from(".p-top__intro-text.js-gsap", {
			duration: 3,
			delay: 4,
			opacity: 0,
			scrollTrigger: {
				trigger: '.p-top__intro-text.js-gsap',
				start: 'top 50%'
			}
		});

		// p-top__intro-mv
		gsap.from(".p-top__intro-mv.js-gsap", {
			delay: 4,
			opacity: 0,
			y: 70,
			scrollTrigger: {
				trigger: '.p-top__intro-mv.js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		// p-top__intro-explanation
		gsap.from(".p-top__intro-explanation.js-gsap", {
			duration: 2,
			delay: 2,
			opacity: 0,
			scrollTrigger: {
				trigger: '.p-top__intro-explanation.js-gsap',
			}
		});

		// p-top__item item-01
		gsap.from(".p-top__item.item-01 .p-top__item-intro .js-gsap", {
			duration: 1.5,
			opacity: 0,
			x: -20,
			y: -30,
			scrollTrigger: {
				trigger: '.p-top__item.item-01 .p-top__item-intro .js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		gsap.from(".p-top__item.item-01 .c-buy.buy-01.js-gsap", {
			delay: 1,
			opacity: 0,
			x: 200,
			scrollTrigger: {
				trigger: '.p-top__item.item-01 .c-buy.buy-01.js-gsap',
			}
		});

		gsap.from(".p-top__item.item-01 .c-buy.buy-01 .c-buy__ttl.js-gsap", {
			delay: 1.5,
			opacity: 0,
			x: -200,
			scrollTrigger: {
				trigger: '.p-top__item.item-01 .c-buy.buy-01 .c-buy__ttl.js-gsap',
			}
		});

		gsap.from(".p-top__item.item-01 .c-buy.buy-01 .c-buy__product.js-gsap", {
			delay: 2,
			opacity: 0,
			y: 40,
			scrollTrigger: {
				trigger: '.p-top__item.item-01 .c-buy.buy-01 .c-buy__product.js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		// p-top__item item-02
		gsap.from(".p-top__item.item-02 .p-top__item-intro .js-gsap", {
			duration: 1.5,
			opacity: 0,
			x: -20,
			y: -30,
			scrollTrigger: {
				trigger: '.p-top__item.item-02 .p-top__item-intro .js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		gsap.from(".p-top__item.item-02 .c-buy.buy-02.js-gsap", {
			delay: 1,
			opacity: 0,
			x: -200,
			scrollTrigger: {
				trigger: '.p-top__item.item-02 .c-buy.buy-02.js-gsap',
			}
		});

		gsap.from(".p-top__item.item-02 .c-buy.buy-02 .c-buy__ttl.js-gsap", {
			delay: 1.5,
			opacity: 0,
			x: -200,
			scrollTrigger: {
				trigger: '.p-top__item.item-02 .c-buy.buy-02 .c-buy__ttl.js-gsap',
			}
		});

		gsap.from(".p-top__item.item-02 .c-buy.buy-02 .c-buy__product.js-gsap", {
			delay: 2,
			opacity: 0,
			y: 40,
			scrollTrigger: {
				trigger: '.p-top__item.item-02 .c-buy.buy-02 .c-buy__product.js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		// p-top__item item-03
		gsap.from(".p-top__item.item-03 .p-top__item-intro .js-gsap", {
			duration: 1.5,
			opacity: 0,
			x: -20,
			y: -30,
			scrollTrigger: {
				trigger: '.p-top__item.item-03 .p-top__item-intro .js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		gsap.from(".p-top__item.item-03 .c-buy.buy-03.js-gsap", {
			delay: 1,
			opacity: 0,
			x: 200,
			scrollTrigger: {
				trigger: '.p-top__item.item-03 .c-buy.buy-03.js-gsap',
			}
		});

		gsap.from(".p-top__item.item-03 .c-buy.buy-03 .c-buy__ttl.js-gsap", {
			delay: 1.5,
			opacity: 0,
			x: -200,
			scrollTrigger: {
				trigger: '.p-top__item.item-03 .c-buy.buy-03 .c-buy__ttl.js-gsap',
			}
		});

		gsap.from(".p-top__item.item-03 .c-buy.buy-03 .c-buy__product.js-gsap", {
			delay: 2,
			opacity: 0,
			y: 40,
			scrollTrigger: {
				trigger: '.p-top__item.item-03 .c-buy.buy-03 .c-buy__product.js-gsap',
			},
			stagger: {
				from: "start",
				amount: .8,
			}
		});

		// p-top__bnr
		gsap.from(".p-top__bnr-inner.js-gsap", {
			opacity: 0,
			y: 70,
			scrollTrigger: {
				trigger: '.p-top__bnr-inner.js-gsap',
			}
		});

	});

})(jQuery);

// MV ローディング
$(window).on('load', function () {
	setTimeout(function () {
		$(".l-header__inner").addClass('js-appear');
		$(".l-header__loading").addClass('js-disappear');
	}, 2000);
});

// MV YouTube背景
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
var ytPlayer;

function onYouTubeIframeAPIReady() {
	ytPlayer = new YT.Player('js-bg__youtube', {
		videoId: 'wMuNc5Pv298',
		playerVars: {
			playsinline: 1,
			autoplay: 1,
			fs: 0,
			rel: 0,
			controls: 0,
			modestbranding: 1,
			iv_load_policy: 3,
			start: 0,
		},
		events: {//　イベント
			'onReady': onPlayerReady,
			'onStateChange': onPlayerStateChange
		}
	});
}

//MV YouTube ミュートにしてから再生する設定
function onPlayerReady(event) {
	event.target.mute();
	event.target.playVideo();
}

//MV YouTube ループ設定
function onPlayerStateChange(event) {
	if (event.data == YT.PlayerState.ENDED) {
		event.target.playVideo();
	}
}
